var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.24333 0 0 4.24333 0 9.5C0 14.7567 4.24333 19 9.5 19C14.7567 19 19 14.7567 19 9.5C19 4.24333 14.7567 0 9.5 0ZM10.5556 13.9122C10.5556 14.4823 10.07 14.9467 9.5 14.9467C8.92996 14.9467 8.44444 14.4823 8.44444 13.9122V8.50778C8.44444 7.93774 8.92996 7.4733 9.5 7.4733C10.07 7.4733 10.5556 7.93774 10.5556 8.50778V13.9122ZM9.52107 6.12222C8.95104 6.12222 8.48659 5.65778 8.48659 5.08774C8.48659 4.5177 8.95104 4.05326 9.52107 4.05326C10.0911 4.05326 10.5556 4.5177 10.5556 5.08774C10.5556 5.65778 10.0911 6.12222 9.52107 6.12222Z",
    fill: "#A2A7B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.ee187244e121ab473e52fdb7df385ecf.svg";
export { ForwardRef as ReactComponent };